import { SSRGlobal } from "@/frontend/components/qecomps/Context"

export default (langobj = null): PConfig => {

    let z;
    if (langobj) {
        z = SSRGlobal(null, langobj)
    }
    else {
        z = SSRGlobal()
    }


    if (!langobj) {
        langobj = z.lang || {}
    }
    if (!langobj) {
        langobj = z.langs?.en || {}
    }


    let tolstr = (num: number, fracdigits: number, removedigits: number, remdig: boolean = false): string => {
        if (removedigits && remdig) {
            num = num - num % Math.pow(10, removedigits);
        }
        return num.toLocaleString(langobj.region || "en-US", {
            maximumFractionDigits: fracdigits,
            minimumFractionDigits: fracdigits,
        })
    }

    let units: Units =
    {
        usd: {
            key: "usd",
            image: global.cdn("/files/flags/us.svg"),
            fullname: langobj.unitsfullname?.["usd"],
            name: langobj.units?.["usd"],
            tousd: 1.0,
            fractions: 2,
            removedigits: 0,
            ccode: "us",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0, rmdig),
        },
        eur: {
            key: "eur",
            image: global.cdn("/files/flags/eur.svg"),
            fullname: langobj.unitsfullname?.["eur"],
            name: langobj.units?.["eur"],
            tousd: 1.13,
            fractions: 2,
            removedigits: 0,
            ccode: "euro",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0, rmdig),
        },
        gbp: {
            key: "gbp",
            image: global.cdn("/files/flags/gb.svg"),
            fullname: langobj.unitsfullname?.["gbp"],
            name: langobj.units?.["gbp"],
            tousd: 1.33,
            fractions: 2,
            removedigits: 0,
            ccode: "gb",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0, rmdig),
        },
        cad: {
            key: "cad",
            image: global.cdn("/files/flags/cad.svg"),
            fullname: langobj.unitsfullname?.["cad"],
            name: langobj.units?.["cad"],
            tousd: 0.71,
            fractions: 2,
            removedigits: 0,
            ccode: "ca",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0, rmdig),
        },
        aud: {
            key: "aud",
            image: global.cdn("/files/flags/au.svg"),
            fullname: langobj.unitsfullname?.["aud"],
            name: langobj.units?.["aud"],
            tousd: 0.64,
            fractions: 2,
            removedigits: 0,
            ccode: "au",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0, rmdig),
        },
        toman: {
            key: "toman",
            image: global.cdn("/files/irr.svg"),
            fullname: langobj.unitsfullname?.["toman"],
            name: langobj.units?.["toman"],
            tousd: 1 / (global.tmnusd),
            fractions: 0,
            removedigits: 2,
            ccode: "ir",
            tolocalstr: (num, rmdig = false) => tolstr(num, 0, 3),
        },
        rial: {
            key: "rial",
            image: global.cdn("/files/irr.svg"),
            fullname: langobj.unitsfullname?.["rial"],
            name: langobj.units?.["rial"],
            tousd: 1 / (10 * global.tmnusd),
            fractions: 0,
            removedigits: 3,
            ccode: "ir",
            tolocalstr: (num, rmdig = false) => tolstr(num, 0, 3),
        },
        usdt: {
            key: "usdt",
            image: global.cdn("/files/tether.svg"),
            fullname: langobj.unitsfullname?.["usdt"],
            name: langobj.units?.["usdt"],
            tousd: 1.0,
            fractions: 2,
            removedigits: 0,
            ccode: "tether",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0),
        },
        tron: {
            key: "tron",
            image: global.cdn("/files/tron.svg"),
            fullname: langobj.unitsfullname?.["tron"],
            name: langobj.units?.["tron"],
            tousd: 0.25,
            fractions: 2,
            removedigits: 0,
            ccode: "tron",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0),
        },
        usdc: {
            key: "usdc",
            image: global.cdn("/files/usdc.svg"),
            fullname: langobj.unitsfullname?.["usdc"],
            name: langobj.units?.["usdc"],
            tousd: 1.0,
            fractions: 2,
            removedigits: 0,
            ccode: "usdc",
            tolocalstr: (num, rmdig = false) => tolstr(num, 2, 0),
        },
    };

    let userallowedunits: Array<UnitName> =
        [
            "usd", "eur", "gbp", "aud", "cad", "toman", "usdt"
        ];

    let deposits: Array<MethodName> =
        [
            "usdttrc20",
            "usdtbep20",
            "wm", "pm",
            "ironline",
            // "usdctrc20", 
            // "usdcbep20", 
            "serial"
        ];

    let withdrawals: Array<MethodName> =
        [
            "usdttrc20", "usdtbep20", "wm", "pm", "irshebawithdraw",
        ];

    let transfers: Array<WalletName> =
        [
            "toman", "qetoman", "tether", "pm", "wm", "tron", "usdc"
        ];


    let payments: Array<MethodName> =
        [
            "usdttrc20",
            "usdtbep20",
            // "usdctrc20", 
            // "usdcbep20", 
            "wm", "pm", "qetoman", "ironline",// "ircardtocard"
        ];

    let wallets: Wallets =
    {
        toman: {
            key: "toman",
            name: langobj.wallets?.["toman"],
            balance: z.user?.wallets?.toman?.balance || 0,
            unit: units.toman,
            image: global.cdn("/files/irr.svg"),
            minimum:
            {
                transfer: 5000,
            },
            fee: {
                transfer: 1000
            },
            maxfee://if fee was percent it's the ceiling, 0 means unlimited
            {
                transfer: 0,
            },
            donations: [5000, 10000, 20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000,
                2000000, 5000000]
        },
        qetoman: {
            key: "qetoman",
            name: langobj.wallets?.["qetoman"],
            balance: z.user?.wallets?.qetoman?.balance || 0,
            unit: units.toman,
            image: global.cdn("/files/irr.svg"),
            minimum:
            {
                transfer: 5000,
            },
            fee: {
                transfer: 0
            },
            maxfee://if fee was percent it's the ceiling, 0 means unlimited
            {
                transfer: 0,
            },
            donations: []
        },
        tether:
        {
            key: "tether",
            name: langobj.wallets?.["tether"],
            balance: z.user?.wallets?.tether?.balance || 0,
            unit: units.usdt,
            image: global.cdn("/files/tether.svg"),
            minimum:
            {
                transfer: 5,
            },
            fee: {
                transfer: "1%"
            },
            maxfee://if fee was percent it's the ceiling, 0 means unlimited
            {
                transfer: 0,
            },
            donations: [1, 2, 3, 5, 10, 15, 20, 30, 50, 100, 200, 300]
        },
        tron:
        {
            key: "tron",
            name: langobj.wallets?.["tron"],
            balance: z.user?.wallets?.tron?.balance || 0,
            unit: units.tron,
            image: global.cdn("/files/tron.svg"),
            minimum:
            {
                transfer: 10,
            },
            fee: {
                transfer: 1
            },
            maxfee://if fee was percent it's the ceiling, 0 means unlimited
            {
                transfer: 0,
            },
            donations: []
        },
        usdc:
        {
            key: "usdc",
            name: langobj.wallets?.["usdc"],
            balance: z.user?.wallets?.usdc?.balance || 0,
            unit: units.usdc,
            image: global.cdn("/files/usdc.svg"),
            minimum:
            {
                transfer: 10,
            },
            fee: {
                transfer: "1%"
            },
            maxfee://if fee was percent it's the ceiling, 0 means unlimited
            {
                transfer: 0,
            },
            donations: []
        },
        wm:
        {
            key: "wm",
            name: langobj.wallets?.["wm"],
            balance: z.user?.wallets?.wm?.balance || 0,
            unit: units.usd,
            image: global.cdn("/files/wm.svg"),
            minimum:
            {
                transfer: 10,
            },
            fee: {
                transfer: "1%"
            },
            maxfee://if fee was percent it's the ceiling, 0 means unlimited
            {
                transfer: 1.0,
            },
            donations: [1, 2, 3, 5, 10, 15, 20, 30, 50, 100, 200, 300]
        },
        pm:
        {
            key: "pm",
            name: langobj.wallets?.["pm"],
            balance: z.user?.wallets?.pm?.balance || 0,
            unit: units.usd,
            image: global.cdn("/files/pm.svg"),
            minimum:
            {
                transfer: 5,
            },
            fee: {
                transfer: "5%"
            },
            maxfee://if fee was percent it's the ceiling, 0 means unlimited
            {
                transfer: 1.0,
            },
            donations: [1, 2, 3, 5, 10, 15, 20, 30, 50, 100, 200, 300]
        },
    };

    let methods: Methods =
    {
        usdttrc20:
        {
            key: "usdttrc20",
            name: langobj.methods?.usdttrc20,
            wallet: wallets?.tether,
            minimum:
            {
                deposit: 3.0,
                withdraw: 3.0,
                purchase: 0,
            },
            fee:
            {
                deposit: "1%",
                withdraw: 1,
                purchase: "1%",
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "two",
            sitewallet: "TZHPTQPdy56vmn9wmWFJTbdaZeL3u1KhuV",
            image: global.cdn("/files/tether.svg"),
            qrcode: global.cdn("/files/qr-trc20.png"),
        },
        usdtbep20:
        {
            key: "usdtbep20",
            name: langobj.methods?.usdtbep20,
            minimum:
            {
                deposit: 5,
                withdraw: 10,
                purchase: 5,
            },
            fee:
            {
                deposit: 0,
                withdraw: "1%",
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "two",
            wallet: wallets?.tether,
            sitewallet: "0x279B7BCc868d24013fAF15F9D562bA882482df99",
            image: global.cdn("/files/tether.svg"),
            qrcode: global.cdn("/files/qr-bep20.png"),
        },
        usdctrc20:
        {
            key: "usdctrc20",
            name: langobj.methods?.usdctrc20,
            minimum:
            {
                deposit: 10,
                withdraw: 10,
                purchase: 0,
            },
            fee:
            {
                deposit: 0,
                withdraw: "1%",
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "two",
            wallet: wallets?.usdc,
            sitewallet: "0x279B7BCc868d24013fAF15F9D562bA882482df99",
            image: global.cdn("/files/usdc.svg"),
            qrcode: global.cdn("/files/qr-trc20.png"),
        },
        usdcbep20:
        {
            key: "usdcbep20",
            name: langobj.methods?.usdcbep20,
            minimum:
            {
                deposit: 10,
                withdraw: 10,
                purchase: 0,
            },
            fee:
            {
                deposit: 0,
                withdraw: "1%",
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "two",
            wallet: wallets?.usdc,
            sitewallet: "0x279B7BCc868d24013fAF15F9D562bA882482df99",
            image: global.cdn("/files/usdc.svg"),
            qrcode: global.cdn("/files/qr-bep20.png"),
        },
        pm:
        {
            key: "pm",
            name: langobj.methods?.pm,
            minimum:
            {
                deposit: 10,
                withdraw: 10,
                purchase: 0,
            },
            fee:
            {
                deposit: 0,
                withdraw: "5%",
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 3.0,
                withdraw: 2.0,
                purchase: 4.0,
            },
            type: "single",
            wallet: wallets?.pm,
            sitewallet: "US541223560",
            image: global.cdn("/files/pm.svg"),
            qrcode: null,

        },
        wm:
        {
            key: "wm",
            name: langobj.methods?.wm,
            minimum:
            {
                deposit: 10,
                withdraw: 10,
                purchase: 0,
            },
            fee:
            {
                deposit: 0,
                withdraw: "1%",
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "single",
            wallet: wallets?.wm,
            sitewallet: "Z796095114144",
            image: global.cdn("/files/wm.svg"),
            qrcode: null,
        },
        ircardtocard:
        {
            key: "ircardtocard",
            name: langobj.methods?.ircardtocard,
            minimum:
            {
                deposit: 100000,
                withdraw: 10000,
                purchase: 0,
            },
            fee:
            {
                deposit: 0,
                withdraw: 10000,
                purchase: 0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "single",
            wallet: wallets?.toman,
            sitewallet: "5041-7210-7864-2585",
            image: global.cdn("/files/irr.svg"),
            qrcode: null,
        },
        qetoman:
        {
            key: "qetoman",
            name: langobj.methods?.qetoman,
            minimum:
            {
                deposit: 0,
                withdraw: 0,
                purchase: 0,
            },
            fee:
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "credit",
            wallet: wallets?.qetoman,
            sitewallet: "QEPALCOM",
            image: global.cdn("/files/irr.svg"),
            qrcode: null,
        },
        ironline:
        {
            key: "ironline",
            name: langobj.methods?.ironline,
            minimum:
            {
                deposit: 5000,
                withdraw: 100000,
                purchase: 0,
            },
            fee:
            {
                deposit: 0,
                withdraw: 5000,
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "ironline",
            wallet: wallets?.toman,
            sitewallet: "",
            image: global.cdn("/files/irr.svg"),
            qrcode: null,
        },
        irshebawithdraw:
        {
            key: "irshebawithdraw",
            name: langobj.methods?.irshebawithdraw,
            minimum:
            {
                deposit: 0,
                withdraw: 10000,
                purchase: 0,
            },
            fee:
            {
                deposit: 0.0,
                withdraw: 10000.0,
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "irshebawithdraw",
            wallet: wallets?.toman,
            sitewallet: "IRxxxxxxxxxxxxxxxxxxxx",
            image: global.cdn("/files/irr.svg"),
            qrcode: null,
        },

        serial: { //only used for deposits
            key: "serial",
            wallet: wallets?.qetoman,
            name: langobj.methods?.serial,
            image: global.cdn("/files/key2.svg"),

            minimum:
            {
                deposit: 0,
                withdraw: 0,
                purchase: 0,
            },
            fee:
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            maxfee: //if fee was percent it's the ceiling, 0 means unlimited
            {
                deposit: 0.0,
                withdraw: 0.0,
                purchase: 0.0,
            },
            type: "serial",
            sitewallet: null,
            qrcode: null,
        },

    }

    var timeextension = (origtimequota: number, origquota: number,
        origprice: number, newtimequota: number, digits: number): number => {
        var price = 0;
        if (origquota == 0) {
            if (newtimequota > 0) {
                price = 0.85 * origprice * newtimequota / (origtimequota);
            }
            else {
                price = 0.9 * origprice * 365 / (origtimequota);
            }
        }
        else {
            if (newtimequota > 0) {
                price = 0.425 * origprice * newtimequota / (origtimequota);
            }
            else {
                price = 0.425 * origprice * 365 / (origtimequota);
            }
        }

        return parseFloat(price.toFixed(digits))
    };


    global.P = {
        units, deposits, withdrawals, transfers,
        payments, wallets, methods, timeextension,
        userallowedunits,
    }

    return global.P
}

export type Unit = {
    key: UnitName
    image: string
    fullname: string
    name: string
    tousd: number
    fractions: number
    removedigits: number
    ccode: string
    tolocalstr: (num: number, rmdig?: boolean) => string
}

export type Method = {
    key: MethodName
    name: string
    wallet: Wallet
    minimum:
    {
        deposit: number | `${number}%`
        withdraw: number | `${number}%`
        purchase: number | `${number}%`
    },
    fee:
    {
        deposit: number | `${number}%`
        withdraw: number | `${number}%`
        purchase: number | `${number}%`
    },
    maxfee: //if fee was percent it's the ceiling, 0 means unlimited
    {
        deposit: number,
        withdraw: number,
        purchase: number,
    },
    type: string;
    sitewallet: string
    image: string
    qrcode: string | null
}

export type Wallet = {
    key: WalletName
    name: string
    balance: number
    unit: Unit
    image: string
    minimum:
    {
        transfer: number
    },
    fee: {
        transfer: number | `${number}%`
    },
    maxfee://if fee was percent it's the ceiling, 0 means unlimited
    {
        transfer: number
    },
    donations: Array<number>
}

export type MethodName = "usdttrc20" | "usdtbep20" | "usdctrc20" | "usdcbep20" | "pm" | "wm" | "ircardtocard" |
    "qetoman" | "ironline" | "irshebawithdraw" | "serial"

export type WalletName = "toman" | "qetoman" | "tron" | "tether" | "usdc" | "wm" | "pm"

export type UnitName = "usd" | "eur" | "gbp" | "usdt" | "toman" | "aud" | "tron" | "usdc" | "cad" | "rial"

export type Units = {
    [key in UnitName]: Unit;
};

export type Wallets = {
    [key in WalletName]: Wallet;
};


export type Methods = {
    [key in MethodName]: Method;
};


export type PConfig =
    {
        units: Units, deposits: Array<MethodName>,
        withdrawals: Array<MethodName>, transfers: Array<WalletName>,
        payments: Array<MethodName>, wallets: Wallets, methods: Methods,
        timeextension: (origtimequota: number, origquota: number,
            origprice: number, newtimequota: number, digits: number) => number,
        userallowedunits: Array<UnitName>,
    }

